import dynamic from 'next/dynamic';

export { PhoneNumberInput } from './PhoneNumberInput';
export const DynamicPhoneNumberInput = dynamic(
  () => import('./PhoneNumberInput')
);
